import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'vtr-user',
	templateUrl: './page-user.component.html',
	styleUrls: ['./page-user.component.scss']
})
export class PageUserComponent implements OnInit {

	title = 'User Settings';

	constructor(
	) { }

	ngOnInit() {

	}

}
